import Vue from "vue";
import { Component, Emit, Prop } from "vue-property-decorator";
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import Datepicker from 'vuejs-datepicker';
import { de, en } from 'vuejs-datepicker/dist/locale';
import { WindowType } from "../../../../util";

declare var window: WindowType;

@Component({
    name: 'DatetimeComponent',
    components: { Datepicker, vSelect }
})
export default class DatetimeComponent extends Vue {
    @Prop({ required: true })
    modalId!: string;
    @Prop({ required: true })
    datetime!: Date;

    private hours: { hour: number, name: string } = { hour: 9, name: '09:00' };
    private selectedDate: Date = new Date();

    private readonly hourOptions = [
        { hour: 0, name: '00:00' },
        { hour: 1, name: '01:00' },
        { hour: 2, name: '02:00' },
        { hour: 3, name: '03:00' },
        { hour: 4, name: '04:00' },
        { hour: 5, name: '05:00' },
        { hour: 6, name: '06:00' },
        { hour: 7, name: '07:00' },
        { hour: 8, name: '08:00' },
        { hour: 9, name: '09:00' },
        { hour: 10, name: '10:00' },
        { hour: 11, name: '11:00' },
        { hour: 12, name: '12:00' },
        { hour: 13, name: '13:00' },
        { hour: 14, name: '14:00' },
        { hour: 15, name: '15:00' },
        { hour: 16, name: '16:00' },
        { hour: 17, name: '17:00' },
        { hour: 18, name: '18:00' },
        { hour: 19, name: '19:00' },
        { hour: 20, name: '20:00' },
        { hour: 21, name: '21:00' },
        { hour: 22, name: '22:00' },
        { hour: 23, name: '23:00' },
    ];
    private readonly datepickerLocales: any = { 'en': en, 'de': de };

    mounted(): void {
        this.selectedDate = new Date(this.datetime);
        this.hours = this.hourOptions.find(e => e.hour === this.datetime.getHours())!;
    }

    private save(): void {
        let d = new Date(this.selectedDate);
        d.setHours(this.hours.hour);
        d.setMinutes(0);
        d.setSeconds(0);

        this.$emit('selected', d);
    }

    @Emit('close')
    private close(): void { }

    private onDateSelected(newval: Date | null): void {
        if (!newval)
            return;
        this.selectedDate = new Date(newval);
    }

    private get showTime(): boolean {
        return window.application.kanban.kanbanshowtime;
    }
}